var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.exportRoute,"target":"_blank"}},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"btn btn-success float-right",staticStyle:{"margin":"4px"}},[_c('i',{staticClass:"fa fa-file-excel-o mr-1"}),_vm._v(" Dados Bancários\n  ")])}]
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-266d7922","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/Bl/ExportAccountsButton.vue
// module id = 890
// module chunks = 1